import request from '@/service/request'

/* 桌球室 时间表，分页
* @params
* */
export const pageSnookerScheduleApi = (params) => {
  return request.post('/stu/snookerRoomSchedule/page', params)
}

/* 桌球室 时间表，list 获取所有权限 管理员和开发人员
* 接口地址准确 因为后端颠颠的，乱来 ，导致几个cell接口命名不规范，跟羽毛球的相反
* @params
* */
export const cellSnookerScheduleApi = (params = {}) => {
  return request.post('/stu/snookerRoomSchedule/cellManager', params)
}

/* 桌球室 时间表，根据核销员权限获取
* @params
* */
export const cellSnookerScheduleByManagerApi = (params = {}) => {
  return request.post('/stu/snookerRoomSchedule/cell', params)
}

/* 桌球室 时间表，根据id获取
* @params
* */
export const getSnookerScheduleByIdApi = (id) => {
  return request.post(`/stu/snookerRoomSchedule/get/${id}`)
}
/* 桌球室 时间表，删除
* @params
* */
export const delSnookerScheduleByIdApi = (id) => {
  return request.post(`/stu/snookerRoomSchedule/del/${id}`)
}

/* 桌球室 时间表，保存
* @params
* */
export const batchBindSnookerScheduleByUserIdApi = (params) => {
  return request.post('/stu/snookerRoomSchedule/manager/saveBatch', params)
}

/* 桌球室 时间表，管理员list
* @params
* */
export const listSnookerAdminApi = (params = {}) => {
  return request.post('/stu/snookerRoomSchedule/manager/list', params)
}

/* 球场模板 type=1 */

/* 桌球室 时间表，模板记录
* @params
* */
export const listSnookerModelApi = (params = {}) => {
  return request.post('/stu/snookerRoomSchedule/list', params)
}

/* 桌球室 时间表，删除模板
* @params
* */
export const delSnookerModelApi = (ids) => {
  return request.post(`/stu/snookerRoomSchedule/del/${ids}`)
}

/* 桌球室 时间表，(多对多)的模板保存
* @params
* */
export const saveSnookerModelApi = (params) => {
  return request.post('/stu/snookerRoomSchedule/saveBatchByRoomIdsAndWeeks', params)
}

/* 桌球室 时间表，编辑当日 启用/禁用后的模板保存
* @params
* */
export const editBatchSnookerOffFlagApi = (params) => {
  return request.post('/stu/snookerRoomSchedule/saveCustomBatchByRoomId', params)
}
